import styled from "styled-components";

export const Copyright = styled.p`
  ${({ theme }) => theme.typography.TinyParagraph};
  color: ${({ theme }) => theme.colors.text.darkerGrey};
`;

export const FooterContainer = styled.div<{ $hasBottomSpacing?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacers.L};
  padding: ${({ theme }) => theme.spacers["2L"]} ${({ theme }) => theme.spacers.L} 0;
  padding-bottom: ${({ theme, $hasBottomSpacing }) => ($hasBottomSpacing ? theme.spacers["5XL"] : 0)};
  margin-bottom: ${({ theme }) => theme.spacers.XL};
`;

export const StyledLink = styled.a`
  ${({ theme }) => theme.typography.TinyParagraph};
  color: ${({ theme }) => theme.colors.text.darkerGrey};
  text-decoration: none;
  margin-left: ${({ theme }) => theme.spacers.L};
  margin-right: ${({ theme }) => theme.spacers.L};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const LinksWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
